
export const config = {
    SCX_BI_MSG_SERVICE_URL: process.env['APP_WP_SERVICE_URL'] || 'http://206.189.138.212:3235/api',
    SCX_BROADCAST_SERVICE_URL: process.env['SCX_APP_WP_SERVICE_URL'] || 'http://206.189.138.212:3233/api',
    SCX_UM_SERVICE_URL: process.env['SCX_UM_SERVICE_URL'] || 'http://206.189.138.212:3234/api',
    
    // SCX_UM_SERVICE_URL: 'http://localhost:3234/api',
    // SCX_BROADCAST_SERVICE_URL: 'http://localhost:3233/api',
    // SCX_BI_MSG_SERVICE_URL: 'http://localhost:3232/api',
    metaWhatsAppConfig:{
        VERSION: 'v19.0',
        PHONE_NUMBER_ID : '305092216017700',
        PHONE_NUMBER_ID_FOR_SEND : '437711296082941',
        ACCESS_TOKEN : 'EAAPlWQYnjvkBO3nJuYbGL6Afc6AKwCt3wz4vp4LD6XSMAWwQkgOeCaDcObuHzbkW4z8QSXUZCO1CvMzVCZBTAtpTZA0sIinwZCPcKBiZCQf4YukEAQ9LB5a6ofpQO4oSmGbBZCzRq2T2GRPYZCo3BAguGhmv9NfrZAaFOZByNUVjoVRExpG2SgROsinlVIM5FJzqUehtG3QfjHeLW7MXM',    
    }
}
